<template>
  <div class="site-wrap">
    <div class="site-mobile-menu site-navbar-target">
      <div class="site-mobile-menu-header">
        <div class="site-mobile-menu-close">
          <span class="icon-close2 js-menu-toggle"></span>
        </div>
      </div>
      <div class="site-mobile-menu-body"></div>
    </div>

    <NavBar />

    <section class="home-section bg-dark overlay" id="home-section">
      <div class="ban">
        <div class="container"></div>
      </div>
    </section>

    <section class="site-section" id="joblist" style="background: #f8f8fb">
      <div
        style="display: flex; justify-content: space-between"
        class="flex-col"
        v-if="employee && !user"
      >
        <Status
          v-if="$route.query.test !== 'test_start'"
          @startTest="startTest"
          class="status"
        />
        <div style="width: 100%" v-if="$route.query.test === 'test_start'">
          <b-container>
            <Test />
          </b-container>
        </div>
        <div class="passport" v-else>
          <Passport v-if="!edit" @editData="editData" />
          <PassportEdit @close="editData" v-else />
          <Files class="ml-3 mr-3" v-if="!edit" />
        </div>
      </div>
    </section>

    <b-modal
      v-model="showAgreement" 
      size="xl"
      :title="$t('register.text.text1')"
      hide-header-close
      no-header-close
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <div
        style="text-align: justify; padding: 21px; "
        v-if="getTitleByCode()"
      >
        <div v-html="getTitleByCode('rules')[$localeKey()]"></div>
        <div style="width: 100%; display:flex; justify-content: center;">
          <b-button @click="IAgree" variant="primary"> {{ $t("login.oferta")  }} </b-button>
        </div>
      </div>
    </b-modal>

  </div>
</template>

<script>
import NavBar from "@/views/NavBar.vue";
import Passport from "@/views/Profile/passport";
import PassportEdit from "@/views/Profile/passportEdit";
import Status from "@/views/Profile/status";
import Files from "@/views/Profile/files";
import Test from "@/views/Profile/test";
import { mapState, mapGetters } from "vuex";
export default {
  name: "Profile",
  data() {
    return {
      edit: false,
      showAgreement: false,
    };
  },
  computed: {
    ...mapState("employee", ["employee", "user", "loader"]),
    ...mapGetters("title", ["getTitleByCode"]),
  },
  methods: {
    editData(b) {
      this.edit = b;
    },
    startTest(item) {
      let id = window.btoa("W29iam" + item.id + "test_status");
      this.$router.push({
        path: "/profile",
        query: {
          test: "test_start",
          id: id,
        },
      });
    },
    IAgree(){
      this.showAgreement = false
      localStorage.setItem("isAgree", "true")
    },

  },
  components: {
    NavBar,
    Passport,
    Status,
    PassportEdit,
    Files,
    Test,
  },
  mounted() {
    this.showAgreement = localStorage.getItem("isAgree") ? false : true   
  },
};
</script>

<style>
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 1200px) {
  .passport {
    width: 100% !important;
  }
  .status {
    width: 100% !important;
  }
  .flex-col {
    flex-direction: column !important;
  }
}
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 575px) {
  .passport {
    width: 100% !important;
  }
  .status {
    width: 100% !important;
  }
  .flex-col {
    flex-direction: column !important;
  }
}
.passport {
  width: 70%;
}
.status {
  width: 30%;
}
.ban {
  width: 100%;
  height: 10vh;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ban img {
  position: absolute;
  top: 0;
  left: 0;
  object-fit: cover;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.ban .container {
  position: relative;
  z-index: 1;
  max-width: 1000px;
  margin: 0 auto;
  text-align: center;
}
</style>
